import React, { useEffect } from "react";
import { Provider } from "react-redux";
import Routes from "./Routes";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./app/features/login/login.config";

/**
 * Root application component.
 * - Initializes MSAL and sets the active account after successful login.
 * - Provides the Redux store to the routing tree.
 */
interface IProps {
  store: any;
}

const Root = ({ store }: IProps) => {
  const msalInstance = new PublicClientApplication(msalConfig);

  useEffect(() => {
    const init = async () => {
      await msalInstance.initialize();
      if (
        !msalInstance.getActiveAccount() &&
        msalInstance.getAllAccounts().length > 0
      ) {
        msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
      }

      // Keep MSAL active account in sync when login succeeds via redirect
      msalInstance.addEventCallback((event: any) => {
        if (
          event.eventType === EventType.LOGIN_SUCCESS &&
          event?.payload?.account
        ) {
          const account = event.payload.account;
          msalInstance.setActiveAccount(account);
        }
      });
    };
    init();
  }, []);

  return (
    <Provider store={store}>
      <Routes msalInstances={msalInstance} />
    </Provider>
  );
};

export default Root;
